<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
    <ManagerSidebar :toggler.sync="isToggled" />
  </div>
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getManagerUserProfile" />

      <Message class="mt-4" type="warning-alert" v-if="alertMessage">
        <p slot="alert-message" class="mb-0">{{ alertMessage }}</p>
      </Message>

      <ManagerSettings />
    </div>
  </div>
</template>

<script>
import TopNavbar from '@/components/Navigations/TopNavbar';
import ManagerSettings from '@/components/Manager/Settings/ManagerSettings';
import ManagerSidebar from '@/components/Navigations/ManagerSidebar';

import Message from '@/components/AlertMessages/Message';
import { userRoleMixin } from '../../mixins/userRoleMixin';
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    TopNavbar,
    ManagerSidebar,
    Message,
    ManagerSettings,
  },
  mixins: [userRoleMixin, toggleSidebarNav],
  data: () => ({ isToggled: false, alertMessage: '' }),
  methods: {
    ...mapActions('managerStoreModule', ['retrieveManagerProfile', 'retrieveManagerUserProfile']),
  },
  computed: { ...mapGetters('managerStoreModule', ['getManagerProfile', 'getManagerUserProfile']) },
  mounted() {
    this.retrieveManagerProfile();
  },
};
</script>
